import React, { useState, useEffect, useRef } from "react";
import { formBtn1, formBtn3, pageClass, pageHeader } from "../Utils/CustomClasses";
import Table from "../Table/Table";
import AddCompany from "./AddCompany";
import Switch from "react-switch";
import Swal from "sweetalert2";
import { GetAllCompanyPaginationAPI, UpdateComapnyAPI } from "../../API/Api";
import ViewCompanyModal from "../Modals/ViewCompanyModal";
import DeleteCompanyModal from "../Modals/DeleteCompanyModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useThemeColor } from "../Sidebar/SideBarApi";
import usePaginatedData from "../Utils/UsePagination";
import { useForm } from "react-hook-form";
import { IconEye, IconTrash } from "@tabler/icons-react";

export default function Company() {
  const filterTimeout = useRef();
  const isFirstRender = useRef(true);
  const [RowData, setrowdata] = useState([]);
  const [CompanyModal, setCompanyModal] = useState(false);
  const themeColor = useThemeColor();
  const [DeleteModal, setDeleteModal] = useState(false);
  const { register } = useForm();
  const UserDetails = useSelector((state) => state?.login?.userDetails);

  const initialFilterState = {
    p: 1,
    parentCompany: UserDetails?.company?._id
  };
  const [filterObject, setFilterObject] = useState({ ...initialFilterState });

  const {
    filterData: companyData,
    pageNo,
    nextIsValid,
    prevIsValid,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
    loader
  } = usePaginatedData(1, 50, GetAllCompanyPaginationAPI, filterObject);

  const HandleViewCompany = (row) => {
    setrowdata(row);
    setCompanyModal(true);
  };

  const HandleDeleteCompany = (row) => {
    setrowdata(row);
    setDeleteModal(true);
  };

  const handleDelistToggle = (checked, rowData) => {
    Swal.fire({
      title: "Warning",
      text: `Do you really want to ${checked ? "list" : "delist"} this company?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      customClass: {
        confirmButton: `${formBtn1}`,
        cancelButton: `${formBtn3}`
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let response = await UpdateComapnyAPI(rowData?._id, { isListed: checked });
          if (response?.status == 201) {
            toast.success(response?.data?.message);
            filterRecords();
          } else {
            toast.error(response?.error)
          }
        } catch (err) {
          console.log("Error:", err);
        }
      }
    });
  };

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;  // Prevent first API call from `useEffect`
      return;
    }
    filterRecords();
  }, [filterObject]);

  const tableColumns = [
    {
      field: "companyName",
      header: "Company Name",
      style: true,
      sortable: true,
    },
    {
      field: "addressLine1",
      header: "Address1",
      style: true,
      sortable: true,
    },
    {
      field: "addressLine2",
      header: "Address2",
      style: true,
      sortable: true,
    },
    {
      field: "companyEmail",
      header: "Company Email",
      style: true,
      sortable: true,
    },
    {
      field: "companyPhone",
      header: "Phone Number",
      style: true,
      sortable: true,
    },
    {
      field: "noOfEmployee",
      header: "Employee limit",
      style: true,
      sortable: true,
    },
    {
      field: "activeUsers",
      header: "Active user",
      style: true,
      sortable: true,
      body: (row) => <span>{row?.activeUsers ?? 0}</span>,
    },
    {
      field: "totalUsers",
      header: "Total user",
      style: true,
      sortable: true,
      body: (row) => <span>{row?.totalUsers ?? 0}</span>,
    },
    {
      field: "noOfRole",
      header: "Role limit",
      style: true,
      sortable: true,
    },
    {
      field: "city",
      header: "City",
      style: true,
      sortable: true,
    },
    {
      field: "state",
      header: "State",
      style: true,
      sortable: true,
    },
    {
      field: "color",
      header: "Color",
      style: true,
      sortable: true,
      body : (row) => (
        <div className="flex items-center gap-2">
        <span className="w-3 h-3" style={{ backgroundColor:`var(${row?.color})` }}></span>
        {row?.color?.replace('--', '')}
      </div>)
    },
    {
      field: "isListed",
      header: "Islisted",
      style: true,
      body: (rowData) => (
        <Switch
          checked={rowData?.isListed}
          onChange={(checked) => handleDelistToggle(checked, rowData)}
          checkedIcon={false}
          uncheckedIcon={false}
          offColor="#ccc"
          onColor="#4CAF50"
        />
      ),
    },
    {
      field: "actions",
      header: "Actions",
      style: true,
      // sortable: true,
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            onClick={(e) => {
              e.preventDefault();
              HandleViewCompany(row);
            }}
            className="py-1 rounded-lg flex justify-center w-1/2"
          >
            <IconEye stroke={1.5} size={24} color="#000" />
          </button>
          <AddCompany edit={true} rowdata={row} filterRecords={filterRecords} />
          <button
            onClick={(e) => {
              e.preventDefault();
              HandleDeleteCompany(row);
            }}
            className="py-1 rounded-lg flex justify-center w-1/2"
          >
           <IconTrash stroke={1.5} size={24} color='red'/>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className={`${pageClass}`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between">
            <h1 className={`${pageHeader} mr-[10px]`}>Company</h1>
            <AddCompany filterRecords={filterRecords} />
          </div>
          <div className="mt-4">
            <Table
              columns={tableColumns}
              data={companyData}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              loading={loader}
            />
          </div>
        </div>
        <ViewCompanyModal
          CompanyModal={CompanyModal}
          setCompanyModal={setCompanyModal}
          row={RowData}
        />
        <DeleteCompanyModal
          DeleteModal={DeleteModal}
          setDeleteModal={setDeleteModal}
          row={RowData}
          filterRecords={filterRecords}
        />
      </div>
    </>
  );
}
